export default function HelpRouteConfig($stateProvider) {

  'ngInject';

  $stateProvider
    .state('help', {
      template: require('./help.html'),
      params: {
        helpPage: null,
        helpItem: null
      },
      controller: 'HelpController',
      url: "/help"
    });
}